import Query from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';

const DeleteUserClusterMutation = async (user_uuid, cluster_id) => (
  await Query(`
    mutation {
      delete_user_cluster(${jsonToInputParams({ user_uuid, cluster_id }) }) {
        success,
        errors
      }
    }
  `)
);

export default DeleteUserClusterMutation;
